import { Button, Group, Tooltip } from '@mantine/core';
import { IconMail, IconPhone } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales';
import type { ReactNode } from 'react';
import { isNonNullish } from 'remeda';

type DirectContactChoiceProps = {
  onCall: () => void;
  onEmail: () => void;
  // Set when the channel cannot be used; the text is surfaced as a tooltip.
  callDisabledReason?: string;
  emailDisabledReason?: string;
};

export const DirectContactChoice = ({
  onCall,
  onEmail,
  callDisabledReason,
  emailDisabledReason,
}: DirectContactChoiceProps) => {
  const { t } = useTranslation();

  return (
    <Group grow>
      <ChoiceButton
        icon={<IconPhone size={18} />}
        label={t(tKeys.MODULES.AT_RISK.DIRECT_CONTACT.CALL)}
        disabledReason={callDisabledReason}
        onClick={onCall}
      />
      <ChoiceButton
        icon={<IconMail size={18} />}
        label={t(tKeys.MODULES.AT_RISK.DIRECT_CONTACT.EMAIL)}
        disabledReason={emailDisabledReason}
        onClick={onEmail}
      />
    </Group>
  );
};

type ChoiceButtonProps = {
  icon: ReactNode;
  label: string;
  disabledReason?: string;
  onClick: () => void;
};

const ChoiceButton = ({ icon, label, disabledReason, onClick }: ChoiceButtonProps) => {
  const isDisabled = isNonNullish(disabledReason);

  return (
    <Tooltip label={disabledReason} disabled={!isDisabled}>
      <Button
        variant="default"
        leftSection={icon}
        onClick={() => !isDisabled && onClick()}
        data-disabled={isDisabled || undefined}
        aria-disabled={isDisabled || undefined}
      >
        {label}
      </Button>
    </Tooltip>
  );
};
